import React from 'react'
import dynamic from 'next/dynamic'

import { i18n } from '@thg-commerce/enterprise-core'
import {
  ProductBlock,
  ProductBlockProps,
} from '@thg-commerce/enterprise-components'

import {
  AbsoluteCloseButton,
  ProductDetailsContainer,
  StyledCloseText,
  StyledCloseWrapper,
  StyledButton,
} from './styles'

export interface ShopTheLookHotSpotProps {
  product: ProductBlockProps & { rangeList?: string }
  onCloseProductDetailsBox: () => void
  className?: string
  hotSpotRef?: React.RefObject<HTMLDivElement>
}

const Close = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/Close'),
)

const CloseIcon = ({ closeLabel }: { closeLabel?: string }) => {
  return (
    <StyledCloseWrapper>
      {closeLabel && <StyledCloseText>{closeLabel}</StyledCloseText>}
      <Close />
    </StyledCloseWrapper>
  )
}

export const ShopTheLookHotSpot = ({
  product,
  className,
  onCloseProductDetailsBox,
  hotSpotRef,
}: ShopTheLookHotSpotProps) => {
  const i18nText = {
    closeAriaLabel: i18n('general.modal.close.button.arialabel'),
    closeLabel: i18n('general.modal.close.button.label'),
    reviewsStarsLabel: i18n('reviews.stars.label'),
    reviewsLabel: i18n('reviews.reviews.label'),
    shopButton: {
      title: i18n('widget.shop.the.look.range.shop.text'),
    },
    viewItemButton: i18n('widget.shop.the.look.product.more.text'),
  }

  return (
    <ProductDetailsContainer
      tabIndex={0}
      ref={hotSpotRef}
      className={className}
      data-testid="shop-the-look-hot-spot-container"
    >
      <AbsoluteCloseButton
        aria-label={i18nText.closeAriaLabel}
        onClick={onCloseProductDetailsBox}
        data-testid="shop-the-look-close-button"
      >
        <CloseIcon closeLabel={i18nText.closeLabel} />
      </AbsoluteCloseButton>
      <ProductBlock
        {...product}
        review={
          product.review
            ? {
                ...product.review,
                screenReaderOnlyText: `${product.review.starRating} ${i18nText.reviewsStarsLabel} ${product.review.numberOfReviews} ${i18nText.reviewsLabel}`,
              }
            : undefined
        }
        button={{
          title: i18nText.viewItemButton,
          quickBuyTitle: i18nText.viewItemButton,
        }}
      />
      {product.rangeList && (
        <StyledButton
          href={product.rangeList}
          emphasis="medium"
          renderedAs="a"
          data-testid="shop-the-look-shop-button"
        >
          {i18nText.shopButton.title}
        </StyledButton>
      )}
    </ProductDetailsContainer>
  )
}
